<script>
  import ApiClientCore from './core'
  import IndicatorsMixin from './mixins/indicator';
  import DifficultyMixin from './mixins/difficulty';
  import SessionMixin from './mixins/session';
  import ScenarioMixin from './mixins/scenario';
  import UserMixin from './mixins/user';

  export default {
    name: 'api-client',
    extends: ApiClientCore,
    mixins: [
        IndicatorsMixin,
        DifficultyMixin,
        SessionMixin,
        ScenarioMixin,
        UserMixin
    ]
  }
</script>
